"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var moment = require("moment");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./style.scss");
function getBillingReference(billing) {
    if (billing.type === 'CUSTOM') {
        return billing.referenceNumber;
    }
    if (billing.type === 'INTERNAL' && billing.selectedProject !== undefined) {
        var project = (billing.projects || []).find(function (x) { return x.id === billing.selectedProject; });
        if (project) {
            return project.projectName;
        }
    }
    return '';
}
var SummaryHeader = function () {
    var summaryText = (0, translation_1.getLocalization)('userfront/order/step4/summary/summary');
    var headerText = (0, translation_1.getLocalization)('userfront/order/step4/summary/title/basicInformation');
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, summaryText),
        React.createElement("div", { className: 'order-summary-header' },
            React.createElement("strong", null, headerText))));
};
/*
 * Creates a column component for the summary content.
 * @param labelKey The key of the label to display.
 */
var createColumn = function (labelKey) {
    return function (_a) {
        var value = _a.value;
        return (React.createElement(sok_ui_1.Grid.Column, { medium: 6 },
            React.createElement("strong", null,
                (0, translation_1.getLocalization)(labelKey),
                ":"),
            React.createElement("br", null), value !== null && value !== void 0 ? value : '-'));
    };
};
var SummaryContentBillingInformation = createColumn('userfront/order/step4/summary/billingInformation');
var SummaryContentCreatedAt = createColumn('userfront/order/step4/summary/createdAt');
var SummaryContentCreatedBy = createColumn('userfront/order/step4/summary/createdBy');
var SummaryContentOrderConfirmation = createColumn('userfront/order/step4/summary/orderConfirmation');
var SummaryContentOrderName = createColumn('userfront/order/step4/summary/orderName');
var SummaryContentProjectName = createColumn('userfront/order/step4/summary/project');
var SummaryContentReference = createColumn('userfront/order/step4/summary/reference');
var SummaryContentRequestedTimeOfDelivery = createColumn('userfront/order/step4/summary/requestedTimeOfDelivery');
var SummaryContentRows = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var billlingInformation = (_a = props.values.billingInformation) === null || _a === void 0 ? void 0 : _a.customerName;
    var createdAt = moment((_b = props.values.createdAt) !== null && _b !== void 0 ? _b : new Date()).format('L LT');
    var createdBy = "".concat((_d = (_c = props.values.author) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : '-', ", ").concat((_f = (_e = props.values.author) === null || _e === void 0 ? void 0 : _e.company) !== null && _f !== void 0 ? _f : '-');
    var orderConfirmation = (_h = (_g = props.values.author) === null || _g === void 0 ? void 0 : _g.email) !== null && _h !== void 0 ? _h : props.user.fold('-', function (user) { return user.email; });
    var orderName = props.values.name;
    var projectName = props.currentProject.name;
    var reference = props.values.billingInformation &&
        getBillingReference(props.values.billingInformation);
    var requestedTimeOfDelivery = moment(props.values.requestTimeOfDelivery).format('L LT');
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Grid.Row, { className: 'summary-row' },
            React.createElement(SummaryContentProjectName, { value: projectName }),
            React.createElement(SummaryContentBillingInformation, { value: billlingInformation })),
        React.createElement(sok_ui_1.Grid.Row, { className: 'summary-row' },
            React.createElement(SummaryContentOrderName, { value: orderName }),
            React.createElement(SummaryContentReference, { value: reference })),
        React.createElement(sok_ui_1.Grid.Row, { className: 'summary-row' },
            React.createElement(SummaryContentCreatedBy, { value: createdBy }),
            React.createElement(SummaryContentRequestedTimeOfDelivery, { value: requestedTimeOfDelivery })),
        React.createElement(sok_ui_1.Grid.Row, { className: 'summary-row' },
            React.createElement(SummaryContentCreatedAt, { value: createdAt }),
            React.createElement(SummaryContentOrderConfirmation, { value: orderConfirmation }))));
};
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('SummaryOrderWizard'), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (_nextProps) {
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'order-summary' },
    React.createElement(SummaryHeader, null),
    React.createElement("div", { className: 'summary-content' },
        React.createElement(SummaryContentRows, __assign({}, props))))); });
